/**
 * Responsible for showing/hiding content based on a tab structure
 * @module modules/tabs
 */
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

const JS_TABS_DEFAULT_OPTIONS = {
  tab: '.tabs__link',
  tabContent: '.tabs__content',
  tabContentActive: 'tabs__content--active',
  tabActive: 'tabs__link--active',
  tabToggleOff: false,
  tabUrl: '',
};

const makeToggleTab = ($tab, initialActiveClass, activeClass, tabToggleOff) => ($target) => {
  const isTabActive  = $target.hasClass(activeClass)
  $tab
    .removeClass(activeClass)
    .find('.u-screen-reader')
    .remove();
  if (isTabActive && tabToggleOff) {
    $target
    .removeClass(activeClass)
    .find('.u-screen-reader').remove();
  } else {
    $target
    .addClass(activeClass)
    .append('<span class="u-screen-reader" aria-live="assertive"> has been selected</span>');
  }
  if (initialActiveClass) {
    $tab.removeClass(initialActiveClass);
    $tab.attr('aria-selected', false);
    $target.addClass(initialActiveClass);
    $target.attr('aria-selected', true);
  }
};

const showImages = (target) => {
  // lazy load hidden tab images on click
  // * consider only loading images in view and then using scroll to load the rest
  const $lazyImages = $(target).find('img[data-src]').not('.loaded');
  if ($lazyImages.length) {
    $lazyImages.lazy({
      bind: "event",
      effect: 'fadeIn'
    }).addClass('loaded');
  }
};

const makeToggleContent = ($content, tabContentActive, tabToggleOff) => ($target) => {
  const $contentSelector = $($target.data('tab-content'));
  const isTabContentActive = $contentSelector.hasClass(tabContentActive);

  $content.removeClass(tabContentActive);
  if (isTabContentActive && tabToggleOff) {
    $contentSelector.removeClass(tabContentActive);
  } else {
    $contentSelector.addClass(tabContentActive).parent().children().not($contentSelector).removeClass(tabContentActive);
  }
  showImages($contentSelector);
};

const resizeSlick = ($target, slickTarget) => {
  const contentSelector = $target.data('tab-content');
  const $slickCarousel = $(contentSelector).find(slickTarget);
  $slickCarousel.slick('setPosition');
}

const tabs = (el, options = {}) => {
  const $el = $(el);
  const {
    tab,
    tabContent,
    tabActive,
    tabContentActive,
    tabToggleOff,
    tabUrl,
  } = Object.assign({}, JS_TABS_DEFAULT_OPTIONS, $el.data(), options);

  const $tab = $el.find(tab);
  const $content = $el.find(tabContent);
  const $tabContentActive = $el.find('.' + tabContentActive); // needed for call to showImages();
  const activeTabClass = $el.data('active-tab') ? $el.data('active-tab').replace('.', '') : false;
  const toggleTab = makeToggleTab($tab, activeTabClass, tabActive, tabToggleOff);
  const toggleContent = makeToggleContent($content, tabContentActive, tabToggleOff);
  showImages($tabContentActive);
  
  $tab.on('click', (e) => {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const slickTarget = $target.data('tab-slick-initializer');
    const tabUrl = $target.data('tab-url');
    toggleTab($target);
    toggleContent($target);
    if (tabUrl && !$target.hasClass('loaded')) {
      $.ajax({
        url: tabUrl,
        success: function(response) {
          const contentSelector = $target.data('tab-content');
          const $tabContent = $(contentSelector);
          $tabContent.html(response);
          showImages($tabContent[0]);
          $target.addClass('loaded');
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error(`${textStatus} ${errorThrown}`);
        }
      });
    }
    if(slickTarget) {
      resizeSlick($target, slickTarget);
    }
  });
};

registerJQueryPlugin('tabs', tabs);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/tabs.js